'use client';

import { motion } from 'framer-motion';
import TrailingLink from '@/components/atoms/TrailingLink';
import styles from './CTASection.module.scss';

export interface CTAButton {
  href: string;
  text: string;
  variant?: 'primary' | 'secondary';
}

interface CTASectionProps {
  title: string;
  description: string;
  buttons: CTAButton[];
  className?: string;
}

export function CTASection({ title, description, buttons, className }: CTASectionProps) {
  return (
    <section className={`${styles.cta} ${className || ''}`}>
      <motion.div
        className={styles.ctaContent}
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
      >
        <h2 className={styles.ctaTitle}>{title}</h2>
        <p className={styles.ctaDescription}>{description}</p>
        <div className={styles.ctaButtons}>
          {buttons.map((button, index) => (
            <TrailingLink
              key={index}
              href={button.href}
              className={button.variant === 'secondary' ? styles.secondaryButton : styles.primaryButton}
            >
              {button.text}
            </TrailingLink>
          ))}
        </div>
      </motion.div>
    </section>
  );
}

export default CTASection;